import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/main.css'
// Initialize Firebase
import './firebase/config'

createApp(App).use(router).mount('#app')
